module.exports = __webpack_public_path__ + "media/images/front/services/after_sales_service-bf3c074c68e83bbe162fd4815584a88f.webp";